import { render, staticRenderFns } from "./outbound-call-message.vue?vue&type=template&id=3851b4a2"
import script from "./outbound-call-message.vue?vue&type=script&lang=js"
export * from "./outbound-call-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3851b4a2')) {
      api.createRecord('3851b4a2', component.options)
    } else {
      api.reload('3851b4a2', component.options)
    }
    module.hot.accept("./outbound-call-message.vue?vue&type=template&id=3851b4a2", function () {
      api.rerender('3851b4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/outbound-call-message.vue"
export default component.exports